<div class="page-wrapper">
    <sfx-loader></sfx-loader>
</div>
